const KEYS = new Set(['operandi-human-context-pending-v1', 'operandi-workflow-pending-v1',
  'operandi-mapping-review-pending-v1']);
let revision = 0;
export const operandiRetryRevision = () => revision;

export function clearOperandiRetryState() {
  revision += 1;
  try {
    const storage = window.sessionStorage;
    const keys = Array.from({length:storage.length}, (_, index) => storage.key(index));
    let cleared = true;
    for (const key of keys) {
      if (!KEYS.has(key) && !key?.startsWith('operandi-grant-pending-v1:')) continue;
      try { storage.removeItem(key); } catch { cleared = false; }
    }
    return cleared;
  } catch { return false; }
}
